import gql from 'graphql-tag';

/** Gets details of the current logged in user */
export const LoggedInUserQuery = gql`
    query LoggedInUserQuery {
        loggedInUser {
            id
            user {
                id
                username
                name
                isAdministrator
                
            }
        }
    }
`;

/** Signs the current user out of the current session */
export const LogoutMutation = gql`
    mutation LogoutMutation {
        logout {
            success
        }
    }
`;

/** Disconnects the current user from Strava, and deletes the user record and all cached data */
export const DisconnectMutation = gql`
    mutation DisconnectMutation {
        disconnect {
            success
        }
    }
`;



// WEBPACK FOOTER //
// ./src/client/components/Login/queries.ts